// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preview[data-v-4179bf8c] {\n  padding: 1rem;\n  overflow-y: auto;\n  height: 150px;\n  max-height: 150px;\n  border-radius: 0.215rem;\n  border: 1px solid #e4eaec;\n}\n.flex-grow[data-v-4179bf8c] {\n  flex: 1 0 auto;\n  max-width: 300px;\n}", ""]);
// Exports
module.exports = exports;
